/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable no-restricted-imports */

import { WithProjectContextInjectedProps, useProjectContext } from "areas/projects/context";
import { RouteComponentProps, withRouter } from "react-router";
import { ProjectRouteParams } from "areas/projects/components/ProjectsRoutes/ProjectRouteParams";
import React from "react";
import { Item } from "primitiveComponents/form/Select/Select";
import { repository } from "clientInstance";
import { VcsBranchResource, ProjectResource, ProcessType } from "client/resources";
import BusyIndicator from "components/BusyIndicator";
import IconButton from "material-ui/IconButton";
import { transitions } from "material-ui/styles";
import Popover, { Origin } from "components/Popover";
import { ThirdPartyIcon, ThirdPartyIconType } from "primitiveComponents/dataDisplay/Icon";
import Events from "material-ui/utils/events";
import ReactDOM from "react-dom";
import * as PropTypes from "prop-types";
import Menu from "components/Menu/Menu";
import ClearFix from "material-ui/internal/ClearFix";
import FilterSearchBox from "components/FilterSearchBox";
import { MenuItem } from "material-ui";
import { OctopusTheme, withTheme } from "components/Theme";
const keycode = require("keycode");
const styles = require("./style.less");
import ActionButton, { ActionButtonType } from "components/Button";
import { SvgIcon } from "@material-ui/core";
import { generatePath } from "react-router-dom";
import { buildBranchNamesList, getTextValuePairForBranch } from "../../../../utils/BranchHelpers/BranchHelpers";
import { useSelector } from "react-redux";
import { useOptionalRunbookContext, WithOptionalRunbookContextInjectedProps } from "../Runbooks/RunbookContext";
import { isVersionControlledProcess } from "../Process/Common/CommonProcessHelpers";
import RequestRaceConditioner from "utils/RequestRaceConditioner";
import Section from "components/Section";

const GitIcon = (props: any) =>
    withTheme((theme) => (
        <SvgIcon {...props} htmlColor={theme.iconNeutral} style={{ fill: theme.iconNeutral, width: "0.7rem", height: "auto" }} viewBox="0 0 640 1024">
            {/* eslint-disable-next-line */}
            <path d="M512 192c-71 0-128 57-128 128 0 47 26 88 64 110v18c0 64-64 128-128 128-53 0-95 11-128 29v-303c38-22 64-63 64-110 0-71-57-128-128-128s-128 57-128 128c0 47 26 88 64 110v419c-38 22-64 63-64 110 0 71 57 128 128 128s128-57 128-128c0-34-13-64-34-87 19-23 49-41 98-41 128 0 256-128 256-256v-18c38-22 64-63 64-110 0-71-57-128-128-128z m-384-64c35 0 64 29 64 64s-29 64-64 64-64-29-64-64 29-64 64-64z m0 768c-35 0-64-29-64-64s29-64 64-64 64 29 64 64-29 64-64 64z m384-512c-35 0-64-29-64-64s29-64 64-64 64 29 64 64-29 64-64 64z" />
        </SvgIcon>
    ));

function getStyles(context: any, theme: OctopusTheme) {
    const spacing = context.muiTheme.baseTheme.spacing;
    const palette = context.muiTheme.baseTheme.palette;
    return {
        control: {
            cursor: "pointer" as const,
            height: "100%",
            position: "relative" as const,
            width: "100%",
        },
        icon: {
            width: `1.5rem`,
            height: `1.5rem`,
            padding: 0,
            right: 0,
            top: 0,
            marginTop: 0,
            fill: theme.secondaryText,
        },
        iconChildren: {
            fill: "inherit",
        },
        label: {
            display: "flex" as const,
            alignItems: "center" as const,
            color: palette.textColor,
            height: `2rem`,
            lineHeight: `2rem`,
            overflow: "hidden" as const,
            opacity: 1,
            position: "relative" as const,
            paddingRight: spacing.desktopGutter,
            textOverflow: "ellipsis" as const,
            paddingLeft: spacing.desktopGutterMini,
        },
        labelWhenOpen: {
            opacity: 0,
            top: spacing.desktopToolbarHeight / 8,
        },
        root: {
            display: "inline-block",
            fontSize: spacing.desktopDropDownMenuFontSize,
            height: `2rem`,
            fontFamily: context.muiTheme.baseTheme.fontFamily,
            outline: "none",
            position: "relative",
            transition: transitions.easeOut(),
        },
        rootWhenOpen: {
            opacity: 1,
        },
        buttons: {
            position: "absolute" as const,
            right: 0,
            top: "0.2rem",
        },
        dropDownMenu: {
            display: "block",
            border: `1px solid ${theme}`,
            borderRadius: 5,
        },
        filter: {
            margin: "0 1rem",
            display: "flex",
            flexDirection: "row" as any,
            alignItems: "center",
        },
        empty: {
            margin: "0 1rem",
        },
    };
}

interface FilterableDropDownMenuProps {
    onChange: (value: string) => void;
    items: Item[];
    totalItems: number;
    value: any;
    empty?: string;
    onFilterChanged?(value: string): Promise<Item[]>;
    onRequestRefresh(): Promise<void>;
}

interface FilterableDropDownMenuState {
    open: boolean;
    anchorElement: any;
    filter: string | undefined;
    filteredItems: Item[] | null;
    isBusySearching: boolean; // UX: Localised refresh indicator pattern.
    isBusyRefreshing: boolean;
}

class FilterableDropDownMenu extends React.Component<FilterableDropDownMenuProps, FilterableDropDownMenuState> {
    static muiName = "DropDownMenu";
    static contextTypes = {
        muiTheme: PropTypes.object.isRequired,
    };
    private searchRaceConditioner = new RequestRaceConditioner();

    constructor(props: FilterableDropDownMenuProps) {
        super(props);
        this.state = {
            open: false,
            anchorElement: null,
            filter: undefined,
            filteredItems: null,
            isBusySearching: false,
            isBusyRefreshing: false,
        };
    }

    private menu: Menu | undefined;
    rootNode = undefined as any;
    arrowNode = undefined as any;

    /**
     * This method is deprecated but still here because the TextField
     * need it in order to work. TODO: That will be addressed later.
     */
    getInputNode() {
        const rootNode = this.rootNode;

        rootNode.focus = () => {
            this.setState({
                open: !this.state.open,
                anchorElement: this.rootNode,
            });
        };

        return rootNode;
    }

    handleTouchTapControl = (event: React.MouseEvent) => {
        event.preventDefault();
        this.setState({
            open: !this.state.open,
            anchorElement: this.rootNode,
        });
    };

    handleRequestCloseMenu = () => {
        this.close(false);
    };

    handleEscKeyDownMenu = () => {
        this.close(true);
    };

    handleKeyDown = (event: React.KeyboardEvent<{}>) => {
        switch (keycode(event)) {
            case "up":
            case "down":
            case "space":
            case "enter":
                event.preventDefault();
                this.setState({
                    open: true,
                    anchorElement: this.rootNode,
                });
                break;
        }
    };

    handleFilterKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        switch (keycode(event)) {
            case "esc":
                this.close(true);
                break;
            case "down":
                if (this.menu && React.Children.count(this.props.children) > 0) {
                    event.preventDefault();
                    this.menu.setFocusIndex(event, 0, true);
                }
                break;
        }
    };

    handleItemTouchTap = (event: any, child: any, index: number) => {
        event.persist();
        event.preventDefault();
        this.setState(
            {
                open: false,
            },
            () => {
                if (this.props.onChange) {
                    this.props.onChange(child.props.value);
                }

                this.close(Events.isKeyboard(event));
            }
        );
    };

    handleChange = (event: any, value: any) => {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    close = (isKeyboard: boolean) => {
        this.setState(
            {
                open: false,
                //filter: undefined, //UX: review - we should refactor this Popover component so all filtering can be unmounted when we close.
                //filteredItems: null,
            },
            () => {
                if (isKeyboard) {
                    const dropArrow = this.arrowNode;
                    // eslint-disable-next-line react/no-find-dom-node
                    const dropNode = ReactDOM.findDOMNode(dropArrow) as HTMLElement;
                    dropNode.focus();
                    dropArrow.setKeyboardFocus(true);
                }
            }
        );
    };

    private handleFilterChanged = async (value: string) => {
        // Reset any filteredItems we're currently viewing _before_ the search begins, otherwise you end up staring at stale items while a search is happening / feels wrong.
        this.setState({ filter: value, filteredItems: [], isBusySearching: true });
        await this.searchRaceConditioner.avoidStaleResponsesForRequest(this.getFilteredResults(value), (filteredItems) => {
            this.setState({ filteredItems, isBusySearching: false });
        });
    };

    private getFilteredResults = async (value: string) => {
        let filteredItems: Item[] = [];
        if (this.props.onFilterChanged) {
            filteredItems = await this.props.onFilterChanged(value);
        } else {
            filteredItems = this.props.items.filter((item) => {
                return item.text.toLowerCase().search(value.toLowerCase()) !== -1;
            });
        }
        return filteredItems;
    };

    private onRequestRefresh = async () => {
        await this.doBusyTaskForRefreshing(this.props.onRequestRefresh);
    };

    private renderFetch() {
        return (
            <div>
                <div className={styles.fetchButtonContainer}>
                    <ActionButton type={ActionButtonType.Secondary} label="FETCH" title="Fetch the latest branches from your configured remote repository" onClick={this.onRequestRefresh} className={styles.fetchButton} />
                </div>
                {this.state.isBusyRefreshing && <BusyIndicator show={true} />}
            </div>
        );
    }

    private renderDropDown = (theme: OctopusTheme) => {
        const anchorOrigin: Origin = {
            vertical: "bottom",
            horizontal: "left",
        };

        const { items, value } = this.props;
        const { anchorElement, open } = this.state;

        const { prepareStyles } = this.context.muiTheme;
        const inlineStyles = getStyles(this.context, theme);

        const activeItems = this.state.filteredItems ?? items;

        return (
            <div
                ref={(node) => {
                    this.rootNode = node;
                }}
                className={styles.dropDownMenu}
                style={prepareStyles(Object.assign({}, inlineStyles.root, open && inlineStyles.rootWhenOpen))}
            >
                {/*This should ideally be a button html element (semantic html is much better for accessibility)
                This breaks the styling enough that I didn't want to commit to this change right now in the short time that I have.*/}
                <div role="button" onClick={this.handleTouchTapControl} aria-label="Switch branch">
                    <ClearFix style={inlineStyles.control}>
                        <div style={inlineStyles.label}>
                            <GitIcon />
                            <span className={styles.value}>{value}</span>
                        </div>
                        <div style={inlineStyles.buttons}>
                            <IconButton
                                onKeyDown={this.handleKeyDown}
                                ref={(node) => {
                                    this.arrowNode = node;
                                }}
                                style={Object.assign({}, inlineStyles.icon)}
                                iconStyle={inlineStyles.iconChildren}
                                {...{ "aria-label": "ToggleDropDown" }}
                            >
                                <ThirdPartyIcon iconType={ThirdPartyIconType.ArrowDropDown} />
                            </IconButton>
                        </div>
                    </ClearFix>
                </div>
                <Popover anchorOrigin={anchorOrigin} anchorEl={anchorElement} open={open} onClose={this.handleRequestCloseMenu}>
                    <div onKeyDown={this.handleFilterKeyDown} style={inlineStyles.filter}>
                        <FilterSearchBox placeholder={"Search for branches..."} autoFocus={true} value={this.state.filter} onChange={this.handleFilterChanged} fullWidth={true} />
                    </div>
                    <Menu
                        ref={(menu: Menu) => (this.menu = menu)}
                        disableAutoFocus={true}
                        maxHeight={400}
                        desktop={true}
                        value={value}
                        onEscKeyDown={this.handleEscKeyDownMenu}
                        onItemTouchTap={this.handleItemTouchTap}
                        selectedMenuItemStyle={{ color: theme.primary }}
                        autoWidth={true}
                        width={null}
                    >
                        {this.state.isBusySearching && (
                            <Section>
                                <BusyIndicator show={this.state.isBusySearching} inline={true} />
                            </Section>
                        )}
                        {activeItems.length === 0 && this.props.empty && !this.state.isBusySearching && <span style={inlineStyles.empty}>{this.props.empty}</span>}
                        {activeItems.map((item, index) => {
                            // Needs preventDefault onMouseDown to prevent https://www.chromestatus.com/features/6662647093133312
                            return (
                                <MenuItem
                                    style={{ whiteSpace: "normal", lineHeight: "1.4", padding: "0.4rem 1rem 0.4rem 0", minHeight: "0" }}
                                    innerDivStyle={{ padding: "0 1rem" }}
                                    onMouseDown={(e) => e.preventDefault()}
                                    key={item.value ?? index}
                                    value={item.value}
                                    primaryText={item.text}
                                />
                            );
                        })}
                    </Menu>
                    {activeItems.length < this.props.totalItems && (
                        <div className={styles.warning}>
                            Displaying {activeItems.length} out of {this.props.totalItems} branches.
                        </div>
                    )}
                    {this.renderFetch()}
                </Popover>
            </div>
        );
    };

    private doBusyTaskForRefreshing = async (action: () => Promise<void>): Promise<void> => {
        this.setState({ isBusyRefreshing: true });
        try {
            await action();
        } finally {
            this.setState({ isBusyRefreshing: false });
        }
    };

    render() {
        return withTheme((theme) => {
            return this.renderDropDown(theme);
        });
    }
}

interface GlobalConnectedProps {
    isConfigurationAsCodeForRunbooksEnabled?: boolean;
}

function isVcsBranchResource(branch: unknown): branch is VcsBranchResource {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (branch as VcsBranchResource).Name !== undefined;
}

async function ensureSelectedAndDefaultBranchesExist(branch: string | VcsBranchResource, collection: Item[], project: Readonly<ProjectResource>) {
    // Note: If a branch is selected that doesn't exist in the base collection of branches, insert it.
    // This may occur if a branch is searched for that is older than the 'latest n' retrieved by default
    const branchName = isVcsBranchResource(branch) ? branch.Name : branch;

    let items: Item[] = collection;
    if (!items.find((item) => item.value === branchName)) {
        const branchResource = isVcsBranchResource(branch) ? branch : await repository.Projects.getBranch(project, branchName);
        items = [getTextValuePairForBranch(branchResource, project), ...items];
    }

    if (!items.find((item) => item.value === project.VersionControlSettings.DefaultBranch)) {
        const branchResource = await repository.Projects.getBranch(project, project.VersionControlSettings.DefaultBranch);
        items = [getTextValuePairForBranch(branchResource, project), ...items];
    }

    return items;
}

type BranchSelectorProps = WithProjectContextInjectedProps & WithOptionalRunbookContextInjectedProps & GlobalConnectedProps & RouteComponentProps<ProjectRouteParams>;

const BranchSelectorInternal: React.FC<BranchSelectorProps> = (props: BranchSelectorProps) => {
    const [branches, setBranches] = React.useState<Item[]>([]);
    const [totalBranches, setTotalBranches] = React.useState<number>(0);
    const project = props.projectContext.state.model;

    const calculateNewPath = (branchName: string): string => {
        const newUrl = generatePath(props.match.path, { ...props.match.params, branchName });
        return newUrl + props.location.pathname.substr(props.match.url.length);
    };

    const injectBranchIntoLocation = (newBranch: string) => {
        const newPath = calculateNewPath(newBranch);
        props.history.push({ ...props.location, pathname: newPath });
    };

    const onChanged = async (newBranch: string | undefined) => {
        if (!newBranch) {
            throw new Error("We should not be here!");
        }

        // Note: When we have a newly selected branch, all we need to do is push it into our router history
        // Note: The props will then flow back into BranchSelector and its initialization useEffect will be triggered
        // Note: As it has a dependency on props.projectContext.state.branch, which in turn changes with there is a new branchName route match
        injectBranchIntoLocation(newBranch);
    };

    const refresh = async () => {
        const selectedBranch = props.projectContext.state.branch;
        if (!selectedBranch) return;

        const branchResources = await repository.Projects.getBranches(project, true);
        const items = await ensureSelectedAndDefaultBranchesExist(selectedBranch.Name, buildBranchNamesList(branchResources.Items, project), project);
        setBranches(items);
        setTotalBranches(branchResources.TotalResults);
        props.projectContext.actions.onBranchSelected(project, selectedBranch.Name);
    };

    const search = async (value: string) => {
        const branchResources = await repository.Projects.searchBranches(project, value);
        return buildBranchNamesList(branchResources.Items, project);
    };

    React.useEffect(() => {
        async function retrieveBranches(branch: VcsBranchResource) {
            const branchResources = await repository.Projects.getBranches(project);

            // Note: there is a chance that the resource passed to us isn't in the collection returned by getBranches, as it only returns the latest `n` active branches
            // Note: if it isn't in the collection retrieved, we will insert it here
            setBranches(await ensureSelectedAndDefaultBranchesExist(branch, buildBranchNamesList(branchResources.Items, project), project));
            setTotalBranches(branchResources.TotalResults);
        }

        if (project && project.IsVersionControlled && props.projectContext.state.branch) {
            retrieveBranches(props.projectContext.state.branch);
        }
    }, [project, props.projectContext.state.branch]);

    const isVersionControlled = isVersionControlledProcess(props.projectContext.state.model.IsVersionControlled, props.runbookContext ? ProcessType.Runbook : ProcessType.Deployment, !!props.isConfigurationAsCodeForRunbooksEnabled);
    const emptyElementNecessaryForActionListSpacing = <div />;
    return isVersionControlled && props.projectContext.state.branch ? (
        <div id="branchSelector" className={styles.selectContainer}>
            <FilterableDropDownMenu value={props.projectContext.state.branch.Name} items={branches} totalItems={totalBranches} empty="No branches found" onChange={onChanged} onRequestRefresh={refresh} onFilterChanged={search} />
        </div>
    ) : (
        emptyElementNecessaryForActionListSpacing
    );
};

const isConfigurationAsCodeForRunbooksEnabledSelector = (state: GlobalState) => state.configurationArea.features.isConfigurationAsCodeForRunbooksEnabled;

export const BranchSelector: React.FC<RouteComponentProps<ProjectRouteParams>> = (props) => {
    const isConfigurationAsCodeForRunbooksEnabled = useSelector(isConfigurationAsCodeForRunbooksEnabledSelector);
    const projectContext = useProjectContext();
    const runbookContext = useOptionalRunbookContext();
    return <BranchSelectorInternal {...props} projectContext={projectContext} runbookContext={runbookContext} isConfigurationAsCodeForRunbooksEnabled={isConfigurationAsCodeForRunbooksEnabled} />;
};

export default withRouter(BranchSelector);
